import { Inject, Injectable } from '@angular/core';
import { COMMISSION_REPOSITORY, CommissionsRepository } from '@core/repositories/commissions.repository';
import { Commission } from '@shared/interfaces/commission';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommissionsService {
  constructor(
    @Inject(COMMISSION_REPOSITORY) protected repository: CommissionsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(commission: Commission): Observable<any> {
    return this.repository.add(commission);
  }

  edit(commission: Commission): Observable<any> {
    return this.repository.edit(commission);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
